import { Box } from "@mui/material";
import { Header } from "./components/header";
import { useState, useEffect, useRef } from "react";
import DashboardContent from "./components/content";
import { DateRange } from "./api/types";
import { useModuleWalkthrough } from "../../common/components/walkthroughV3/useModuleWalkthrough";
import WalkthroughTrigger from "../../common/components/walkthroughV3/walkthrough-trigger";
import { dashboardSteps } from "./components/walkthrough-types";
import { dashboardQuizQuestions } from "./components/quiz";

// 80px DrawerHeader spacer + 48px vertical padding from the main wrapper (p: 3)
const APP_CHROME_HEIGHT = 128;

const Dashboard: React.FC = () => {
  const [dateRange, setDateRange] = useState<DateRange | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const { walkthroughUI, handleLightbulbClick, isWalkthroughActive, currentStepIndex } = useModuleWalkthrough({
    steps: dashboardSteps,
    questions: dashboardQuizQuestions,
    storageKey: "dashboard-walkthrough",
    trackKey: "Dashboard",
    isEnabled: true,
    onNext: () => {},
    onCloseAll: () => {},
    quizTitle: "Dashboard Knowledge Check",
    moduleName: "Dashboard",
  });

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const fit = () => {
      // Reset to 1 so scrollHeight reflects true content height, then scale to fit
      el.style.setProperty("zoom", "1");
      const naturalHeight = el.scrollHeight;
      const available = window.innerHeight - APP_CHROME_HEIGHT;
      el.style.setProperty("zoom", String(Math.min(1, available / naturalHeight)));
    };

    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        pb: 2,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box sx={{ flex: 1 }}>
          <Header onDateChange={setDateRange} walkthroughMenuOpen={isWalkthroughActive && currentStepIndex === 1} />
        </Box>
        <WalkthroughTrigger
          id="wt-dashboard-button"
          onClick={handleLightbulbClick}
        />
      </Box>
      <DashboardContent
        dateRange={dateRange}
        isWalkthroughActive={isWalkthroughActive}
        walkthroughProductFilterOpen={isWalkthroughActive && currentStepIndex === 5}
      />
      {walkthroughUI}
    </Box>
  );
};

export default Dashboard;
